/*
 *| THIS SERVICE IS USED TO FETCH STATISTICS DATA SHOWN ON THE DASHBOARD
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { throwError, of } from 'rxjs';

import * as moment from 'moment';
import jwt_decode from 'jwt-decode';

import { BACKBONE_URL } from '../../shared/constants';
import { StatisticsResponse } from '../../shared/models/statistics.model';


@Injectable({
  providedIn: 'root'
})
export class StatisticsService {

  constructor(private httpClient: HttpClient) { }

  //SIGN IN METHOD
  public getStatistics() {
    let address = BACKBONE_URL + 'Statistics';
    return this.httpClient.get(address);
  }
}
